import { render, staticRenderFns } from "./BannerLegal.html?vue&type=template&id=63861d4a&scoped=true&"
import script from "./BannerLegal.ts?vue&type=script&lang=ts&"
export * from "./BannerLegal.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/banner-legal/_banner-legal.scss?vue&type=style&index=0&id=63861d4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63861d4a",
  null
  
)

export default component.exports